import React from 'react';
import git from '../../Assets/img/github.png'
import linkedin from '../../Assets/img/linkedin.png'
import insta from '../../Assets/img/instagram.png'
import profile from '../../Assets/img/profile.png'
import crown from '../../Assets/img/crown.png'
import bg from '../../Assets/img/glasses.png'
import { Link } from 'react-router-dom';


const Intro = () => {
    return (
        <div class="hero lg:mt-16  mt-24 ">
        <div class="hero-content flex-col lg:flex-row-reverse ">
     <div className="">

     <h1  data-aos="zoom-in-up" data-aos-duration="1000" data-aos-delay="500" className='lg:w-56 h-16 lg:ml-24 rounded-3xl flex items-center bg-primary justify-center px-5 py-3 '><img className='w-10' src={crown} alt="" /><span className='text-white ml-7 font-bold'>MERN developer </span> </h1>
          <img data-aos="fade-left" data-aos-duration="1000" data-aos-delay="500" src={profile}  style={{width:'1100px'}} alt='' />
          </div>
          <div className=''>
         
            <h1 data-aos="fade-right" data-aos-duration="1000" data-aos-delay="500" class="text-3xl lg:text-5xl font-bold"> Hy! I am <p className='text-primary mt-7'> <img className='lg:w-16 w-10  lg:ml-96 ml-60 lg:top-16  bottom-1  absolute  ' src={bg} alt="" /> Md. Abir Rahaman </p> </h1>
            
            <p data-aos="fade-right" data-aos-duration="2000" data-aos-delay="500" class="py-6 font-extrabold">& I'm a MERN stack developer. I'm a dedicated web developer who focuses in React.</p>
            <div  data-aos="fade-right" data-aos-duration="3000" data-aos-delay="500"  className="">  <a  href="https://drive.google.com/file/d/1AQg9oyC5oJ384BfANI0sWoOiDt7A5E5s/view?usp=sharing" target="_blank" rel="noopener noreferrer"> <button  className='btn btn-outline btn-primary rounded-full px-10 pt-1 font-extrabold'> Get Resume </button></a></div>
    
          
            <div data-aos="fade-right" data-aos-duration="1000" data-aos-delay="500"  className="icons flex mt-10">
             
              <a href="https://github.com/Abir-Rahaman" target="_blank" rel="noopener noreferrer"><img className='w-8 hover:scale-150 duration-500' src={git} alt="" /></a>
               
            <a className='ml-8' href="https://www.linkedin.com/in/md-abir-rahaman-2351a6213/" target="_blank" rel="noopener noreferrer"><img className='w-8 hover:scale-150 duration-500' src={linkedin} alt="" /></a>  
              <a className='ml-8' href="https://www.instagram.com/accounts/login/" target="_blank" rel="noopener noreferrer"><img className='w-8 hover:scale-150 duration-500' src={insta} alt="" /></a>
            </div>
          </div>
        </div>
      </div>
    );
};

export default Intro;